import { FormattedMessage } from 'react-intl';

import { SignDocumentStep } from '../../SignDocumentStep/SignDocumentStep';

export const SignPersonalGuarantee = () => {
    return (
        <SignDocumentStep
            title={
                <FormattedMessage
                    id="_.funding_requirements.personal_guarantee_step.title"
                    defaultMessage="Sign Personal Guarantee"
                />
            }
            subtitle={
                <FormattedMessage
                    id="_.funding_requirements.personal_guarantee_step.subtitle"
                    defaultMessage="Please read the entire agreement and click 'Sign personal guarantee' to continue."
                />
            }
            buttonLabel={
                <FormattedMessage
                    id="_.funding_requirements.personal_guarantee_step.sign_button"
                    defaultMessage="Sign personal guarantee"
                />
            }
            type="guarantee"
            requirementType="PERSONAL_GUARANTEE"
        />
    );
};
